/* this file is transformed by vux-loader */
/* eslint-disable */
import _regenerator from "E:/pm-ningde/ppos-web-propertyManage/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/pm-ningde/ppos-web-propertyManage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Flexbox from "vux/src/components/flexbox/flexbox.vue";
import FlexboxItem from "vux/src/components/flexbox/flexbox-item.vue";
import Cell from "vux/src/components/cell/index.vue";
import Xhead from '@/components/XHeader';
import { workOrderInfo } from '@/api/exammine';
import { actionHandle } from '@/api/problemHandling';
import { uploadImage } from '@/utils/common';
import Vue from 'vue';
export default {
  components: {
    Xhead: Xhead,
    Flexbox: Flexbox,
    FlexboxItem: FlexboxItem,
    Cell: Cell
  },
  data: function data() {
    return {
      bigImgSrc: '',
      bigShadow: false,
      timeOut: null,
      showShadow: false,
      title: '问题处理',
      handler_info: {},
      // 处理信息
      initial_info: {},
      // 基础信息
      reviewer_info: {},
      // 审核信息
      related_no: '',
      remark: '',
      action_img: [],
      photo_url: [
        // 'http://192.168.1.200:8055/img001/1/personalLogo/1803/29/1e/2a/2f/1e2a2f14babb446043ed3d23913394e8.jpg?w=100&h=100', 'http://192.168.1.200:8055/img001/1/personalLogo/1803/29/1e/2a/2f/1e2a2f14babb446043ed3d23913394e8.jpg?w=100&h=100', 'http://192.168.1.200:8055/img001/1/personalLogo/1803/29/1e/2a/2f/1e2a2f14babb446043ed3d23913394e8.jpg?w=100&h=100', 'http://192.168.1.200:8055/img001/1/personalLogo/1803/29/1e/2a/2f/1e2a2f14babb446043ed3d23913394e8.jpg?w=100&h=100', 'http://192.168.1.200:8055/img001/1/personalLogo/1803/29/1e/2a/2f/1e2a2f14babb446043ed3d23913394e8.jpg?w=100&h=100', 'http://192.168.1.200:8055/img001/1/personalLogo/1803/29/1e/2a/2f/1e2a2f14babb446043ed3d23913394e8.jpg?w=100&h=100', 'http://192.168.1.200:8055/img001/1/personalLogo/1803/29/1e/2a/2f/1e2a2f14babb446043ed3d23913394e8.jpg?w=100&h=100', 'http://192.168.1.200:8055/img001/1/personalLogo/1803/29/1e/2a/2f/1e2a2f14babb446043ed3d23913394e8.jpg?w=100&h=100', 'http://192.168.1.200:8055/img001/1/personalLogo/1803/29/1e/2a/2f/1e2a2f14babb446043ed3d23913394e8.jpg?w=100&h=100', 'http://192.168.1.200:8055/img001/1/personalLogo/1803/29/1e/2a/2f/1e2a2f14babb446043ed3d23913394e8.jpg?w=100&h=100', 'http://192.168.1.200:8055/img001/1/personalLogo/1803/29/1e/2a/2f/1e2a2f14babb446043ed3d23913394e8.jpg?w=100&h=100', 'http://192.168.1.200:8055/img001/1/personalLogo/1803/29/1e/2a/2f/1e2a2f14babb446043ed3d23913394e8.jpg?w=100&h=100'
      ],
      type: '',
      // 工单类型 type(1:工作监督,问题反馈工单；2：装修申请工单；3：装修问题工单)
      status: '',
      // status状态(0：待处理；1：待审核；2：审核通过；3：审核不通过；4：反馈取消)
      actionStatus: '',
      // { name: '待我处理的', id: '0' }, { name: '我已处理的', id: '1' }
      status_str: ''
    };
  },
  mounted: function mounted() {
    this.related_no = this.$route.query.related_no;
    this.actionStatus = this.$route.query.status;
    this.getOrderDetail();
  },
  methods: {
    showBigPic: function showBigPic(url) {
      if (!url) {
        return;
      }
      url = url.split('?')[0];
      // url = url + '?w=200&h=1200'
      this.bigImgSrc = url;
      this.bigShadow = true;
    },
    hideBigPic: function hideBigPic(url) {
      this.bigShadow = false;
      this.bigImgSrc = '';
    },
    goBack: function goBack() {
      // 返回
      var routerParam = {
        name: 'ProblemHandling',
        query: {
          status: this.actionStatus
        }
      };
      this.$router.push(routerParam);
    },
    handlerOk: function handlerOk() {
      if (!this.remark) {
        Vue.$vux.toast.show({
          type: 'warn',
          text: '请输入处理说明后再操作',
          time: 2000
        });
        return;
      }
      var param = {
        related_no: this.related_no,
        remark: this.remark,
        action_img: this.action_img
      };
      this.showShadowEvent();
      this.getActionHandle(param);
    },
    getOrderDetail: function getOrderDetail() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var param, _yield$workOrderInfo, handler_info, initial_info, reviewer_info, type, type_str, status, status_str;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              param = {
                related_no: _this.related_no
              };
              _context.n = 1;
              return workOrderInfo(param);
            case 1:
              _yield$workOrderInfo = _context.v;
              handler_info = _yield$workOrderInfo.handler_info;
              initial_info = _yield$workOrderInfo.initial_info;
              reviewer_info = _yield$workOrderInfo.reviewer_info;
              type = _yield$workOrderInfo.type;
              type_str = _yield$workOrderInfo.type_str;
              status = _yield$workOrderInfo.status;
              status_str = _yield$workOrderInfo.status_str;
              _this.initial_info = initial_info;
              _this.handler_info = handler_info;
              _this.reviewer_info = reviewer_info;
              _this.status = status;
              _this.status_str = status_str;
              _this.type = type;
              _this.title = type_str;
              // this.$forceUpdate()
              // console.log('jsdaf', this.initial_info, this.type)
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getActionHandle: function getActionHandle(param) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$actionHandle, is_error, msg, error;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return actionHandle(param);
            case 1:
              _yield$actionHandle = _context2.v;
              is_error = _yield$actionHandle.is_error;
              msg = _yield$actionHandle.msg;
              error = _yield$actionHandle.error;
              _this2.hideShadowEvent();
              Vue.$vux.toast.show({
                type: !is_error ? 'success' : 'warn',
                text: msg || error,
                time: 2000
              });
              if (!is_error) {
                _this2.goBack();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    showShadowEvent: function showShadowEvent() {
      var _this3 = this;
      // 显示
      this.$vux.loading.show({
        text: '数据上传中'
      });
      this.showShadow = true;
      this.timeOut = setTimeout(function () {
        _this3.$vux.loading.hide();
        _this3.showShadow = false;
      }, 10000);
    },
    hideShadowEvent: function hideShadowEvent() {
      clearTimeout(this.timeOut);
      this.timeOut = null;
      // 隐藏
      this.$vux.loading.hide();
      this.showShadow = false;
    },
    deleteImg: function deleteImg(index) {
      this.action_img.splice(index, 1);
      this.photo_url.splice(index, 1);
      // console.log(index, this.photo_url, this.action_img)
    },
    // 照片上传
    uploadImg: function uploadImg() {
      if (this.action_img.length >= 6) {
        Vue.$vux.toast.show({
          type: 'warn',
          text: '只能添加6张图片',
          time: 2000
        });
        return;
      }
      this.showShadowEvent();
      uploadImage(this.uploadImageCallback, 'actionImg');
    },
    uploadImageCallback: function uploadImageCallback(data) {
      // alert(JSON.stringify(data))
      this.action_img.push(data.imgPath);
      this.photo_url.push(data.imgUrl);
      this.hideShadowEvent();
      // alert(this.formData.photo_url)
    }
  }
};